import { isPast } from "date-fns";
import { resolveSkipBookDeadline } from "./resolveSkipBookDeadline.js";
export const getFutureDispatches = (dispatches) => {
    const futureDispatches = dispatches.filter(({ distributionDate }) => !!distributionDate && !isPast(new Date(distributionDate)));
    return futureDispatches;
};
/**
 * For book club subscriptions, a dispatch is actionable if the shipment is in
 * the future and cancellation is still allowed.
 *
 * NOTE:
 * - memberExtractionDate does not decide cancellation eligibility.
 * - skipBookDeadline (avbestillingsfrist) is the source of truth for whether
 *   the user can still cancel a dispatch.
 */
export const getValidDispatchesForBookClub = (dispatches) => {
    return dispatches.filter(({ distributionDate, skipBookDeadline }) => {
        // Must have a valid shipment date in the future.
        if (!distributionDate || isPast(new Date(distributionDate))) {
            return false;
        }
        // If a cancellation deadline exists and has passed, this dispatch is no
        // longer actionable for cancellation, so we move on to the next one.
        if (skipBookDeadline && isPast(resolveSkipBookDeadline(skipBookDeadline))) {
            return false;
        }
        return true;
    });
};
